
import React from 'react';
import { Doctor, Staff, Room } from './SchedulerTypes';
import DateTimeFormFields from './DateTimeFormFields';
import ScheduleBasicFields from './ScheduleBasicFields';
import SchedulePersonSelection from './SchedulePersonSelection';
import ScheduleNotesField from './ScheduleNotesField';

export type { ScheduleFormData, ScheduleFormProps } from './ScheduleFormTypes';
export { getInitialFormData, generateTimeOptions } from './ScheduleFormTypes';

interface ScheduleFormDataProps {
  title: string;
  setTitle: (value: string) => void;
  type: 'appointment' | 'admin' | 'break' | 'leave' | 'mc';
  setType: (value: 'appointment' | 'admin' | 'break' | 'leave' | 'mc') => void;
  selectedDoctor: string | undefined;
  setSelectedDoctor: (value: string | undefined) => void;
  doctors: Doctor[];
  selectedStaff: string | undefined;
  setSelectedStaff: (value: string | undefined) => void;
  staff: Staff[];
  orderedStaff?: Staff[];
  selectedRoom: string | undefined;
  setSelectedRoom: (value: string | undefined) => void;
  rooms: Room[];
  startTime: string;
  setStartTime: (value: string) => void;
  endTime: string;
  setEndTime: (value: string) => void;
  notes: string;
  setNotes: (value: string) => void;
  date: Date;
  setDate: (value: Date) => void;
  endDate: Date | undefined;
  setEndDate: (value: Date | undefined) => void;
}

const ScheduleFormData: React.FC<ScheduleFormDataProps> = ({
  title,
  setTitle,
  type,
  setType,
  selectedDoctor,
  setSelectedDoctor,
  doctors,
  selectedStaff,
  setSelectedStaff,
  staff,
  orderedStaff,
  selectedRoom,
  setSelectedRoom,
  rooms,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  notes,
  setNotes,
  date,
  setDate,
  endDate,
  setEndDate,
}) => {
  const [isRecurring, setIsRecurring] = React.useState(!!endDate);

  return (
    <div className="space-y-4">
      <ScheduleBasicFields
        title={title}
        setTitle={setTitle}
        type={type}
        setType={setType}
      />

      <DateTimeFormFields
        startDate={date}
        setStartDate={setDate}
        startTime={startTime}
        setStartTime={setStartTime}
        endDate={endDate}
        setEndDate={setEndDate}
        endTime={endTime}
        setEndTime={setEndTime}
        isRecurring={isRecurring}
        setIsRecurring={setIsRecurring}
      />

      <SchedulePersonSelection
        selectedDoctor={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor}
        doctors={doctors}
        selectedStaff={selectedStaff}
        setSelectedStaff={setSelectedStaff}
        staff={staff}
        orderedStaff={orderedStaff}
        selectedRoom={selectedRoom}
        setSelectedRoom={setSelectedRoom}
        rooms={rooms}
      />

      <ScheduleNotesField
        notes={notes}
        setNotes={setNotes}
      />
    </div>
  );
};

export default ScheduleFormData;
